import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import IconComponent from "src/shared_components/Icons/IconsComponent";
import TaxMappingForm from "./TaxMappingForm";

const TaxMappingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Grid item xs={12} lg={3}>
        <IconComponent
          iconName="AddCircle"
          fontSize="large"
          title={t("Tax Mapping")}
          isWithIcon={true}
        />
      </Grid>
      <Grid item xs={12} lg={12}>
        <TaxMappingForm />
      </Grid>
    </Box>
  );
};

export default TaxMappingPage;
